var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutomaticIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 37,
    viewBox: "0 0 23 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0429 4.57129H1.13525V25.4117H15.0429V4.57129Z",
    stroke: "#29ABE2",
    strokeWidth: 0.859905,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9758 1L15.043 4.57161V25.4117L21.9758 29.0252V1Z",
    stroke: "#29ABE2",
    strokeWidth: 0.859905,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8678 20.9664C5.38147 20.7997 4.19655 19.3976 4.12988 17.3284H5.61516C5.69867 18.7467 6.54955 19.6313 8.38535 19.6313C10.0875 19.6313 11.072 18.9639 11.072 17.6288C11.072 16.494 10.4212 15.9933 9.15308 15.7263L7.45096 15.3589C5.59867 14.9586 4.53059 13.9905 4.53059 12.2052C4.53059 10.42 5.76533 9.20135 7.86816 9.01785V7.64941H9.0029V9.03433C11.0222 9.25117 12.3738 10.5863 12.3903 12.4719H10.905C10.8383 11.2038 10.004 10.3694 8.36851 10.3694C6.98359 10.3694 6.03235 10.9701 6.03235 12.2052C6.03235 13.1565 6.61621 13.6568 7.85131 13.9407L9.43659 14.3081C11.4391 14.7754 12.5906 15.7098 12.5906 17.6288C12.5906 19.5477 11.1889 20.766 9.0029 20.9495V22.3344H7.86816V20.966L7.8678 20.9664Z",
    fill: "#F39200"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36009 24.7393L4.85156 29.0248H7.45689L7.49882 35.9996H9.30559V29.0248H11.8686L8.36009 24.7393Z",
    fill: "#F39200",
    stroke: "#F39200",
    strokeWidth: 0.859905,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomaticIcon);
export default __webpack_public_path__ + "static/media/automaticIcon.a79de4e8f63249041931371c298bcdbe.svg";
export { ForwardRef as ReactComponent };